// src/db/models/responseModel.js
import { api } from '../../api/client';

// Modified ResponseModel.js to ensure consistent response processing
export const ResponseModel = {
  async createMany(performanceId, responses) {
    // Normalize responses to ensure consistent format
    const normalizedResponses = {};
    
    Object.entries(responses).forEach(([questionId, responseData]) => {
      normalizedResponses[questionId] = {
        answer: responseData.answer || responseData,
        isCorrect: responseData.isCorrect === true || responseData.is_correct === true,
      };
    });
    
    return api.saveResponses(performanceId, normalizedResponses);
  },

  async findByPerformanceId(performanceId) {
    const result = await api.getResponses(performanceId);
    
    // Ensure consistent format for the returned responses
    if (result && result.responses) {
      const normalizedResponses = {};
      
      Object.entries(result.responses).forEach(([questionId, responseData]) => {
        normalizedResponses[questionId] = {
          answer: responseData.answer || responseData,
          isCorrect: responseData.isCorrect === true || responseData.is_correct === true
        };
      });
      
      return { ...result, responses: normalizedResponses };
    }
    
    return result;
  }
};